import { render, staticRenderFns } from "./questionnaireLogin.vue?vue&type=template&id=6980a4b2&scoped=true"
import script from "./questionnaireLogin.vue?vue&type=script&lang=js"
export * from "./questionnaireLogin.vue?vue&type=script&lang=js"
import style0 from "./questionnaireLogin.vue?vue&type=style&index=0&id=6980a4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980a4b2",
  null
  
)

export default component.exports